import React, { useEffect, useState, useMemo } from "react";
import Papa from "papaparse";
import Chart from "react-apexcharts";
import {
  Button,
  Card,
  CardHeader,
  Flex,
  Box,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Checkbox,
  CheckboxGroup,
  VStack,
  IconButton,
  Heading,
  CardBody,
  Text,
  HStack,
  Select,
  background,
  RadioGroup,
  Radio,
} from "@chakra-ui/react";
import {
  HiChartBar,
  HiDotsHorizontal,
  HiOutlineDownload,
  HiChevronDown,
  HiChartPie,
} from "react-icons/hi";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  selectedProvincesState,
  selectedPemdaState,
  sidebarisexpandAtom,
  userState,
  months,
  startMonthAtom,
  endMonthAtom,
  tahunAnggaranAtom,
} from "states/recoil";
import { selectedJenisTkdState } from "states/recoil";
import { FaChartLine } from "react-icons/fa";
import VerticalBarChart from "views/Charts/VerticalBarChart";
import LineChartMonthly from "views/Charts/LineChartMonthly";
import DonutChart from "views/Charts/DonutChart";
import HorizontalBarChart from "views/Charts/HorizontalBarChart";
import VerticalBarLineChart from "views/Charts/VerticalBarLineChart";
import { sheetURLSelector } from "states/recoil";

function PenyaluranTKDPemda() {
  //local state
  const [isLoading, setIsLoading] = useState(true);
  const sidebarisexpandGet = useRecoilValue(sidebarisexpandAtom);
  const [tahunAnggaran, setTahunAnggaran] = useRecoilState(tahunAnggaranAtom);

  const sheetURL = useRecoilValue(sheetURLSelector);
  const sheetInfoUpdate =
    "https://docs.google.com/spreadsheets/d/1vTuEXERFF-i-QBj6Vse912Hkv3J5SWhblcPPRIKWuew/gviz/tq?tqx=out:csv&gid=2070513025";

  //filter state
  const [provinceList, setProvinceList] = useState([
    "PROVINSI PAPUA",
    "PROVINSI PAPUA TENGAH",
    "PROVINSI PAPUA SELATAN",
    "PROVINSI PAPUA PEGUNUNGAN",
    "PROVINSI PAPUA BARAT",
    "PROVINSI PAPUA BARAT DAYA",
  ]);
  const [pemdaList, setPemdaList] = useState([]);
  const [jenisTKDList, setJenisTKDList] = useState([]);
  const monthsdata = useRecoilValue(months);
  const [startMonth, setStartMonth] = useRecoilState(startMonthAtom);
  const [endMonth, setEndMonth] = useRecoilState(endMonthAtom);

  //recoil state
  const [selectedProvinces, setSelectedProvinces] = useRecoilState(
    selectedProvincesState
  );
  const [selectedPemda, setSelectedPemda] = useRecoilState(selectedPemdaState);
  const [selectedJenisTKD, setSelectedJenisTKD] = useRecoilState(
    selectedJenisTkdState
  );
  const user = useRecoilValue(userState);

  //chart state
  const [rawData, setRawData] = useState([]);
  const [updatedData, setUpdatedData] = useState("");

  //fetch the data based users province
  useEffect(() => {
    setIsLoading(true);
    if (!user || !user.province) return; // Wait until userState is available
    if (sheetURL.slice(-10) !== tahunAnggaran) return;
    console.log("Fetching data from:", sheetURL.slice(-10), tahunAnggaran);

    fetch(sheetInfoUpdate)
      .then((res) => res.text())
      .then((text) => {
        Papa.parse(text, {
          header: true,
          skipEmptyLines: true,
          complete: (results) => {
            // rows and header fields
            const rows = (results.data || []).filter(
              (r) => r && Object.keys(r).length > 0
            );
            const fields = results.meta?.fields || [];

            // Column B = second field
            const colBKey = fields[1]; // e.g. "UPDATED" if your sheet labels it so

            // Find the last non-empty value in column B
            let lastVal = "";
            for (let i = rows.length - 1; i >= 0; i--) {
              const v = rows[i]?.[colBKey];
              if (v !== undefined && v !== null && String(v).trim() !== "") {
                lastVal = String(v).trim();
                break;
              }
            }

            setUpdatedData(lastVal);
          },
        });
      });

    fetch(sheetURL)
      .then((res) => res.text())
      .then((text) => {
        Papa.parse(text, {
          header: true,
          skipEmptyLines: true,
          complete: (results) => {
            const data = results.data;
            setRawData(data);

            const provinces = Array.from(
              new Set(data.map((row) => row["NM PROV"]).filter(Boolean))
            );
            const pemdas = Array.from(
              new Set(data.map((row) => row["NM PEMDA"]).filter(Boolean))
            );
            const jenisList = Array.from(
              new Set(data.map((row) => row["JENIS TKD"]).filter(Boolean))
            );

            // Determine the user's province name
            let provinceset = "";
            switch (user.province) {
              case "papua":
                provinceset = "PROVINSI PAPUA";
                break;
              case "papua-tengah":
                provinceset = "PROVINSI PAPUA TENGAH";
                break;
              case "papua-pegunungan":
                provinceset = "PROVINSI PAPUA PEGUNUNGAN";
                break;
              case "papua-selatan":
                provinceset = "PROVINSI PAPUA SELATAN";
                break;
              case "papua-barat":
                provinceset = "PROVINSI PAPUA BARAT";
                break;
              case "papua-barat-daya":
                provinceset = "PROVINSI PAPUA BARAT DAYA";
                break;
              default:
                provinceset = "";
                break;
            }

            // Correct this line: it should be an array, not string
            setProvinceList([provinceset]);
            setSelectedProvinces([provinceset]);

            setPemdaList(pemdas);
            setJenisTKDList(jenisList);

            if (selectedProvinces.length === 0) {
              setSelectedProvinces([provinceset]); // select only user’s province
            }

            if (selectedPemda.length === 0) {
              const initialPemda = data
                .filter((row) => row["NM PROV"] === provinceset)
                .map((row) => row["NM PEMDA"]);
              setSelectedPemda(Array.from(new Set(initialPemda)));
            }

            if (selectedJenisTKD.length === 0) {
              setSelectedJenisTKD(jenisList);
            }
          },
        });
        // console.log(rawData[0].THANG);
        setIsLoading(false);
      });
  }, [user, sidebarisexpandGet, sheetURL]);

  // Update pemda options based on selected province
  useEffect(() => {
    if (!rawData.length || !selectedProvinces.length) return;

    const filtered = rawData.filter((row) =>
      selectedProvinces.includes(row["NM PROV"])
    );
    const newPemda = Array.from(
      new Set(filtered.map((row) => row["NM PEMDA"]))
    );

    setPemdaList(newPemda);
    setSelectedPemda(newPemda);
  }, [selectedProvinces, rawData]);

  // Update Jenis TKD options based on selected pemda
  useEffect(() => {
    if (!rawData.length || !selectedPemda.length) return;

    const filtered = rawData.filter((row) =>
      selectedPemda.includes(row["NM PEMDA"])
    );

    const newJenisTKD = Array.from(
      new Set(filtered.map((row) => row["JENIS TKD"]).filter(Boolean))
    );

    setJenisTKDList(newJenisTKD);
    setSelectedJenisTKD(newJenisTKD);
  }, [selectedPemda, rawData]);

  //rule all selcted filter
  const isAllSelected = selectedPemda.length === pemdaList.length;
  const isNoneSelected = selectedPemda.length === 0;
  const displayTextPemda =
    isAllSelected || isNoneSelected ? "Semua Pemda" : selectedPemda[0];

  return (
    <Flex direction="column" gap={4} width="100%">
      <Flex justify="space-between" width="100%" alignItems={"center"}>
        <Flex direction={"column"} gap={1}>
          <Heading size="md">Dashboard Penyaluran TKD</Heading>
          <Text size="sm" fontSize={10}>
            <i>Berdasakan Data OM-SPAN TKD per {updatedData ?? "-"}</i>
          </Text>
        </Flex>
        <Flex gap={4}>
          <Menu closeOnSelect={false}>
            <MenuButton as={Button} rightIcon={<HiChevronDown />}>
              {displayTextPemda}
            </MenuButton>

            <MenuList
              maxHeight="300px"
              overflowY="auto"
              minWidth="250px"
              zIndex={3}
            >
              {/* "Semua Pemda" item */}
              <MenuItem onClick={() => setSelectedPemda([...pemdaList])}>
                Semua Pemda
              </MenuItem>

              {pemdaList.map((pemda) => (
                <MenuItem key={pemda} onClick={() => setSelectedPemda([pemda])}>
                  {pemda}
                </MenuItem>
              ))}
            </MenuList>
          </Menu>

          {/* Filter Jenis TKD */}
          <Menu closeOnSelect={false}>
            <MenuButton
              as={Button}
              rightIcon={<HiChevronDown />}
              variant={"outline"}
              backgroundColor={
                selectedJenisTKD.length === jenisTKDList.length
                  ? "white"
                  : "#CBD5E0"
              }
            >
              Filter Jenis TKD
            </MenuButton>
            <MenuList
              maxHeight="300px"
              overflowY="auto"
              minWidth="200px"
              zIndex={3}
            >
              <CheckboxGroup
                value={selectedJenisTKD}
                onChange={setSelectedJenisTKD}
              >
                <VStack align="start" p={2}>
                  <Checkbox
                    isChecked={selectedJenisTKD.length === jenisTKDList.length}
                    isIndeterminate={
                      selectedJenisTKD.length > 0 &&
                      selectedJenisTKD.length < jenisTKDList.length
                    }
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedJenisTKD(jenisTKDList);
                      } else {
                        setSelectedJenisTKD([]);
                      }
                    }}
                  >
                    Select All
                  </Checkbox>
                  {jenisTKDList.map((jenis) => (
                    <Checkbox key={jenis} value={jenis}>
                      {jenis}
                    </Checkbox>
                  ))}
                </VStack>
              </CheckboxGroup>
            </MenuList>
          </Menu>

          {/* Filter Bulan */}
          <HStack spacing={4} align="center" mb={4}>
            <Box>
              {/* <Text>Start Month</Text> */}
              <Select
                fontWeight={600}
                value={startMonth}
                onChange={(e) => {
                  const selected = e.target.value;
                  setStartMonth(selected);

                  if (
                    monthsdata.indexOf(selected) > monthsdata.indexOf(endMonth)
                  ) {
                    setEndMonth(selected);
                  }
                }}
              >
                {monthsdata.map((month) => (
                  <option key={month} value={month}>
                    {month}
                  </option>
                ))}
              </Select>
            </Box>
            <Text fontWeight={600}>s.d.</Text>
            <Box>
              {/* <Text>End Month</Text> */}
              <Select
                fontWeight={600}
                value={endMonth}
                onChange={(e) => {
                  const selected = e.target.value;

                  if (
                    monthsdata.indexOf(selected) >=
                    monthsdata.indexOf(startMonth)
                  ) {
                    setEndMonth(selected);
                  }
                }}
              >
                {monthsdata.map((month) => {
                  const isDisabled =
                    monthsdata.indexOf(month) < monthsdata.indexOf(startMonth);
                  return (
                    <option key={month} value={month} disabled={isDisabled}>
                      {month}
                    </option>
                  );
                })}
              </Select>
            </Box>
            <Box>
              <Select
                fontWeight={600}
                value={tahunAnggaran}
                onChange={(e) => setTahunAnggaran(e.target.value)}
              >
                {/* list requested */}
                <option value="2064924627">TA 2025</option>
                <option value="2134699857">TA 2024</option>
              </Select>
            </Box>
          </HStack>
        </Flex>
      </Flex>
      <Flex justify="space-between" width="100%" gap={4}>
        <Card width="40%" variant="outline">
          <VerticalBarChart
            data={rawData}
            xaxisData="JENIS TKD"
            titleChart="Kinerja Penyaluran per Jenis TKD"
          />
        </Card>
        <Card width={"40%"} variant={"outline"}>
          <LineChartMonthly
            data={rawData}
            titleChart="Trend Realisasi per Bulan"
          />
        </Card>
        <Card width="20%" variant="outline">
          <DonutChart
            data={rawData}
            selectedData="JENIS TKD"
            titleChart="Prosentase Realisasi terhadap Pagu"
          />
        </Card>
      </Flex>
      <Flex justify="space-between" width="100%" gap={4}></Flex>
      <Flex justify="space-between" width="100%" gap={4}>
        <Card width={"39%"} maxHeight={1500}>
          <HorizontalBarChart
            data={rawData}
            titleChart="Kinerja per Sub Jenis TKD"
          />
        </Card>
        <Flex direction={"column"} width={"60%"} gap={4}>
          <Card height={"100%"}>
            <VerticalBarLineChart
              data={rawData}
              xaxisData="NM PEMDA"
              titleChart="Distribusi TKD per Pemda"
            />
          </Card>
        </Flex>
      </Flex>
    </Flex>
  );
}

export default PenyaluranTKDPemda;
